module.exports = __webpack_public_path__ + "assets/img/CTA-cartoucherie-numerisation_gris.6c40f407.jpg";